module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"vacancyList":"Vacancy list","invitationTitle":"Pass an online interview","applyTitle":"Apply","invitationTip":"Available by invitation only","otherVacancies":"Other jobs from","allVacancies":"All jobs from","more":"More","vacancy":"Vacancy","vacancyCount":"0 jobs | {n} job | {n} jobs | {n} jobs","vacancyArchived":"Job is archived"}}')
  delete Component.options._Ctor
}
